import { render } from "./study.vue?vue&type=template&id=37468381&scoped=true&ts=true"
import script from "./study.vue?vue&type=script&lang=ts"
export * from "./study.vue?vue&type=script&lang=ts"

import "./study.vue?vue&type=style&index=0&id=37468381&scoped=true&lang=scss"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37468381"]])

export default __exports__